<button class="floating-button" (click)="layout.sidebarToggle()"></button>
<nav class="sidebar-nav">
  <button class="inline-button" type="button" (click)="layout.sidebarToggle()">
    <span>Menu</span>
    <mat-icon>keyboard_double_arrow_right</mat-icon>
  </button>
  <oiq-layout-nav
    class="__main-menu"
    [menu]="menu"
    [isSidebarExpanded]="layout.sidebarExpanded$ | async"
    [path]="navPath"></oiq-layout-nav>

  <!-- SETTINGS -->
  <div class="__settings" *ngIf="settingsMenu?.visible">
    <oiq-layout-nav-item
      class="__settings-menu"
      [item]="settingsMenu"
      [isSidebarExpanded]="layout.sidebarExpanded$ | async"
      [path]="navPath"
      [siblings]="menu"></oiq-layout-nav-item>
  </div>
</nav>
